export enum TemplateFilterSection {
  Vertical = 'Vertical',
  UseCase = 'Use Case'
}

export interface PrintStoreTemplatesFilterProps {
  sectionName: TemplateFilterSection
  clearTemplates: () => void
}
